import { Card, Heading, Icon } from '@boltenergy-be/design-system'
import styles from './ConfirmationView.module.scss'
import Link from 'components/link/Link.tsx'
import useGetAccessRight from 'hooks/useSelectAccessRight.ts'
import { routes } from 'types/routes.ts'
import { useTranslation } from 'react-i18next'
import parse from 'html-react-parser'
import { ACCESS_RIGHT_KEYS } from 'store/access-rights/constants.ts'

const ConfirmationView = () => {
  // Access rights
  const { showContent } = useGetAccessRight(ACCESS_RIGHT_KEYS.billingCycles)

  // i18n
  const { t } = useTranslation('consumption', { keyPrefix: 'editMeterReadings.confirmationView' })

  return (
    <>
      <section className={styles.confirmation}>
        <Icon name="check" size={32} className={styles.check} />
        <Heading as="h2" variant="h6">
          {t(($) => $.title)}
        </Heading>
        <p>{parse(t(($) => $.description))}</p>
      </section>

      {showContent.current && (
        <Card as="section" color="neutral" className={styles['instalment-check']}>
          <div className="flex-col gap-200">
            <Card.Title as="h2" variant="h5" serif={false}>
              {t(($) => $.instalmentCheck.title)}
            </Card.Title>
            <p>{t(($) => $.instalmentCheck.description)}</p>
          </div>
          <Link representation="button" isFullwidth href={routes.BILLING_INSTALMENT_CHECK}>
            {t(($) => $.instalmentCheck.action)}
          </Link>
        </Card>
      )}
    </>
  )
}

export default ConfirmationView
